import map from 'lodash-es/map.js';
import get from 'lodash-es/get.js';
import has from 'lodash-es/has';
import find from 'lodash-es/find.js';
import replace from 'lodash-es/replace';
import filter from 'lodash-es/filter.js';
import { addScript } from '../../bundles/helpers/add-script';
import join from "lodash-es/join";
import isEmpty from "lodash-es/isEmpty";
import set from "lodash-es/set";
import debounce from 'lodash-es/debounce';

class MapAvailable {
  constructor(elem) {
    this.$block = $(elem);
    this.$pickup = this.$block.closest('.pickup');
    this.$switch = this.$pickup.find('.pickup__switch');
    this.$search = this.$block.find('.map-available__search');
    this.id = this.$block.data('id');
    this.ins = this;
    this.action = this.$block.data('action-info');
    this.stores = [];
    this.filter = {};
    if (window.ymaps) window.ymaps.ready(this.init);
    else addScript('https://api-maps.yandex.ru/2.1/?apikey=68acff75-4521-4879-ba3c-c4201a09ad74&lang=ru_RU').then(() => window.ymaps.ready(this.init));
  }

  init = () => {
    this.$block.addClass('init');
    this.$search && this.$search.on('input', (evt) => {
      debounce(() => this.updateFilter({ ADDRESS: evt.target.value }), 350)();
    });
    window.getBH((bh) => this.bh = bh);
    this.fetch().then(() => {
      this.updatePoints();
      this.$switch.on('change', this.toggleAvailable);
    });
    this.$block.on('balloonopen', (event, id) => {
      const coordinates = get(find(this.stores, { id }), 'coordinates');
      this.map && this.map.setCenter(coordinates, 17);
      const placemark = find(this.placemarks, { id });
      if (placemark) placemark.balloon.open();
    });
  }
  fetch = () => new Promise((resolve) => {
    if (!this.action && window.Resellers) {
      this.stores = window.Resellers
      resolve(window.Resellers);
    }
    else {
      const info = get(window, ['StoresInfo', join([this.id, this.action], '-')], []);
      if (!isEmpty(info)) {
        this.stores = info;
        resolve(this.stores);
      } else {
        const id = this.id;
        const sessid = window.BX ? window.BX.bitrix_sessid() : '';
        const current = new Date();
        $.ajax(this.action, {
          method: process.env.NODE_ENV === 'development' ? 'GET' : 'POST',
          dataType: 'json',
          data: { id, sessid },
        }).done((response) => {
          const items = get(response, ['result', 'items', this.id], []);
          const stores = get(response, 'result.storesInfo');
          this.stores = map(items.stores, ({ id, date, amount }) => {
            const store = get(stores, id);
            const dateFormat = date;
            return Object.assign({
              id,
              coordinates: [ get(store, 'gpsN'), get(store, 'gpsS') ],
              address: get(store, 'address'),
              phone: get(store, 'phone'),
              time: get(store, 'schedule'),
              inStock: dateFormat === current.toLocaleDateString(),
              amount,
            }, date ? {
              date: dateFormat,
              order: dateFormat === current.toLocaleDateString(),
              supply: current.toLocaleDateString() !== dateFormat,
            }: {})
          });
          set(window, ['StoresInfo', join([this.id, this.action], '-')], this.stores)
          resolve(this.stores);
        })
      }
    }
  })
  createCluster = () => {
    return new this.ymaps.Clusterer({
      clusterIconLayout: 'default#pieChart',
      clusterIconPieChartRadius: 30,
      clusterIconPieChartCoreRadius: 20,
      clusterIconPieChartStrokeWidth: 2,
      hasBalloon: true,
      gridSize: 128,
    })
  }
  createPlacemark = ({ id, coordinates, address, time, phone, inStock, amount }) => {
    const iconImageHref = 'development' === process.env.NODE_ENV ? 'images/heart-o.svg' : '/local/templates/main/dist/images/heart-o.svg';
    const balloonWidth = window.matchMedia('(min-width:992px)').matches ? 264 : 258;
    const balloonOffset = window.matchMedia('(min-width:992px)').matches ? 32 : 10;
    const placemark = new this.ymaps.Placemark(coordinates, {
      balloonContentHeader: address,
      balloonContent: this.bh.apply([
        {block: 'placemark', content: [
            {elem: 'body', content: [
                {cls: 'row m-n2', content: [
                    {cls: 'col-auto py-2 pl-2 pr-0', content: [
                        {elem: 'mark', content: [
                            {block: 'fi', mods: {icon: 'mark'}, tag: 'i'}
                          ]},
                      ]},
                    {cls: 'col p-2', content: [
                        {elem: 'address', content: address},
                        {cls: 'font-size-middle text-lightgray', content: time},
                        {elem: 'link', tag: 'a', cls: 'font-size-middle', attrs: {href: `tel:${phone}`}, content: phone},
                        inStock && {tag: 'b', cls: 'd-block', content: 'В наличии'},
                        {cls: 'mt-20', content: [
                            amount && {block: 'btn', cls: 'btn btn-primary mt-auto', attrs: {'data-action': 'fast', 'data-id': id,}, content: 'Выбрать'}
                          ]}
                      ]},
                  ]},
              ]},
          ]}
      ]),
    }, {
      iconColor: '#2f9343',
      balloonMinWidth: balloonWidth,
      balloonMaxWidth: balloonWidth,
      balloonAutoPan: true,
      balloonAutoPanMargin: balloonOffset,
      iconLayout: 'default#image',
      iconImageHref,
      iconImageSize: [41, 38],
      iconImageOffset: [-15, -36],
      iconContentSize: [30, 28],
      iconContentOffset: [0, 8],
    });
    placemark.id = id;
    if (!this.$block.closest('.modal') || !this.$block.closest('.side-panel')) {
      placemark.events.add('click', () => {
        if (window.matchMedia('(min-width:992px)').matches) {
          const $target = $(`.address-table__link[data-id="${id}"]`);
          if ($target.get(0)) $target.get(0).scrollIntoView({ block: 'center' });
        }
      });
    }
    placemark.events.add('balloonopen', () => {
      this.map && this.map.setCenter(coordinates, 17);
      if(!this.$block.closest('.pickup').length) window.location.hash = `#store${id}`;
    });
    placemark.events.add('balloonclose', () => {
      history.replaceState(null, null, replace(window.location.href, /#store(\d)+/, ''));
    });
    return placemark;
  }
  setPoints = (points) => {
    this.points = points;
    this.placemarks = map(this.points, this.createPlacemark);
    this.cluster.removeAll();
    this.cluster.add(this.placemarks);
  };
  showAllPlacemarks() {
    this.placemarks = map(this.points, this.createPlacemark);
    this.cluster.removeAll();
    this.cluster.add(this.placemarks);
  }
  showAvaliblePlacemarks() {
    const points = filter(this.points, { inStock: true });
    this.placemarks = map(points, this.createPlacemark);
    this.cluster.removeAll();
    this.cluster.add(this.placemarks);
  }
  toggleAvailable = (event) => {
    this.$block.toggleClass('map-available_available', event.target.checked);
    this.refresh();
  }
  lazyInit = () => {
    window.ymaps.ready(() => {
      if (this.points.length) {
        this.ymaps = window.ymaps;
        this.cluster = this.createCluster();
        this.placemarks = map(this.points, this.createPlacemark);
        this.cluster.add(this.placemarks);
        this.map = new this.ymaps.Map(this.$block[0].querySelector('.map-available__content'), {
          useMapMargin: 30,
          bounds: this.cluster.getBounds(),
          controls: [],
        }, {
          maxZoom: 17,
          balloonPanelMaxMapArea: 0, // Отключаем режим панели для балуна на мобильных
        });
        this.map.geoObjects.add(this.cluster);
        this.refresh();
      }
    });
  }
  refresh = () => {
    this.$switch.toggleClass('d-none', !find(this.stores, { inStock: false }) || !find(this.stores, { inStock: true }));
    if(!this.map) {
      if(this.$block.is(":visible")) this.lazyInit();
    } else {
      if(this.$block.hasClass('map-available_available')) this.showAvaliblePlacemarks();
      else this.showAllPlacemarks();
      this.refreshBounds();
    }
  }
  refreshBounds = () => {
    if (~window.location.hash.indexOf('#store')) {
      const id = window.location.hash.substring(6);
      MapAvailable.setActive(id);
    } else {
      const bounds = this.cluster.getBounds();
      if (bounds) this.map.setBounds(this.cluster.getBounds(), {checkZoomRange:true});
    }
  }
  updatePoints = () => {
    this.points = this.stores;
    this.refresh();
  }
  updateFilter = (json) => {
    this.filter = json;
    const filtered = filter(this.stores, (store) => {
      if (has(this.filter, 'ADDRESS')) {
        const address = this.filter['ADDRESS'];
        if (address && !new RegExp(address, 'ig').test(store.address)) return false;
      }
      if (has(this.filter, 'MK')) {
        const mk = this.filter['MK'] === 'Y';
        return !(!mk && store.mk);
      }
      if (has(this.filter, 'OPEN')) {
        const open = this.filter['OPEN'];
        if (open && open !== store.open) return false;
      }
      return true;
    });
    this.points = filtered.length ? filtered : this.stores;
    this.refresh();
  }
  static init() {
    const run = (item) => {
      const map = new MapAvailable(item);
      $(item).data('map', map);
      $(document).on('shown.bs.tab shown.bs.modal', () => map.refresh());
    }

    $('.map-available:not(.init)').each((index, item)=> {
      if (!$(item).data('map')) {

        if (item.closest('.side-panel:not(.open)')) {
          item.closest('.side-panel').addEventListener('iv.open.show', () => run(item), { once: true })
        } else if (item.closest('.modal') && !item.closest('.modal').classList.contains('show')) {
          $(item.closest('.modal')).one('show.bs.modal', () => run(item))
        } else run(item);
      }
    });
  }
  static setActive = (id) => {
    $('.map-available.init').trigger('balloonopen', id);
  }
}

$(document).ready(() => MapAvailable.init());
$(document).on('PageChange', () => MapAvailable.init());

$(window).on('hashchange', () => {
  if (~window.location.hash.indexOf('#store')) {
    const id = window.location.hash.substring(6);
    MapAvailable.setActive(id);
    if (!window.matchMedia('(min-width:992px)').matches) {
      const $map = $('.map-available.init');
      if ($map.get(0)) $map.get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
});

window.Block = window.Block ? window.Block : {};
window.Block.MapAvailable = MapAvailable;
